module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    on: {
      "click": function (e) { return _vm.$emit('click', e); }
    }
  }, [(_vm.type === 1 || _vm.type === 4) ? _c('svg', {
    attrs: {
      "id": "Layer_1",
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 30.19 50.14"
    }
  }, [_c('title', [_vm._v("icons")]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "0.82",
      "y": "0.82",
      "width": "28.55",
      "height": "48.49",
      "fill": "none",
      "stroke": "#010101",
      "stroke-width": "1.64"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0.82",
      "y": "41.31",
      "width": "28.55",
      "height": "8",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.48"
    }
  }), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "1.12",
      "y": "11.23",
      "width": "13.92",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.38"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "5.87",
      "y": "11.23",
      "width": "4.42",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.21"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "1.12",
      "y": "1.14",
      "width": "13.92",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.38"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "5.87",
      "y": "1.14",
      "width": "4.42",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.21"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "1.12",
      "y": "31.32",
      "width": "13.92",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.38"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "5.87",
      "y": "31.32",
      "width": "4.42",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.21"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "1.12",
      "y": "21.23",
      "width": "13.92",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.38"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "5.87",
      "y": "21.23",
      "width": "4.42",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.21"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "14.92",
      "y": "11.23",
      "width": "13.92",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.38"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "19.68",
      "y": "11.23",
      "width": "4.42",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.21"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "14.92",
      "y": "1.14",
      "width": "13.92",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.38"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "19.68",
      "y": "1.14",
      "width": "4.42",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.21"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "14.92",
      "y": "31.32",
      "width": "13.92",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.38"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "19.68",
      "y": "31.32",
      "width": "4.42",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.21"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "14.92",
      "y": "21.23",
      "width": "13.92",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.38"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "19.68",
      "y": "21.23",
      "width": "4.42",
      "height": "10",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.21"
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "14.8",
      "y1": "1.31",
      "x2": "14.8",
      "y2": "41.31",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.9"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.type === 2) ? _c('svg', {
    attrs: {
      "id": "Layer_1",
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 30.19 50.14"
    }
  }, [_c('title', [_vm._v("icons")]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "0.82",
      "y": "0.82",
      "width": "28.55",
      "height": "48.49",
      "fill": "none",
      "stroke": "#010101",
      "stroke-width": "1.64"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0.82",
      "y": "41.31",
      "width": "28.55",
      "height": "8",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.48"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0.82",
      "y": "0.82",
      "width": "28.55",
      "height": "4.52",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.36"
    }
  }), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "1.61",
      "y": "6.13",
      "width": "2.74",
      "height": "3.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "4.35",
      "y": "6.84",
      "width": "1.3",
      "height": "2.46",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "5.65",
      "y": "7.14",
      "width": "3.01",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "8.66",
      "y": "6.76",
      "width": "1.6",
      "height": "2.54",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.12",
      "y": "9.35",
      "width": "9.16",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "1.61",
      "y": "10.71",
      "width": "2.74",
      "height": "2.27",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "4.46",
      "y": "10.81",
      "width": "4.2",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "8.66",
      "y": "11.44",
      "width": "1.6",
      "height": "1.53",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.12",
      "y": "13.02",
      "width": "9.16",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "7.34",
      "y": "14.1",
      "width": "2.67",
      "height": "3.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "6.08",
      "y": "14.81",
      "width": "1.27",
      "height": "2.46",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "3.14",
      "y": "15.11",
      "width": "2.94",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.58",
      "y": "14.73",
      "width": "1.56",
      "height": "2.54",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.56",
      "y": "17.32",
      "width": "8.93",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "7.34",
      "y": "18.68",
      "width": "2.67",
      "height": "2.27",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "3.14",
      "y": "18.78",
      "width": "4.1",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.58",
      "y": "19.41",
      "width": "1.56",
      "height": "1.53",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.56",
      "y": "20.99",
      "width": "8.93",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "1.61",
      "y": "22.35",
      "width": "2.74",
      "height": "3.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "4.35",
      "y": "23.06",
      "width": "1.3",
      "height": "2.46",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "5.65",
      "y": "23.36",
      "width": "3.01",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "8.66",
      "y": "22.99",
      "width": "1.6",
      "height": "2.54",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.12",
      "y": "25.57",
      "width": "9.16",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "1.61",
      "y": "27.84",
      "width": "2.74",
      "height": "2.27",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "4.46",
      "y": "27.94",
      "width": "2.03",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "6.49",
      "y": "27.22",
      "width": "2.15",
      "height": "2.89",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "8.66",
      "y": "28.57",
      "width": "1.6",
      "height": "1.53",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.12",
      "y": "30.15",
      "width": "9.16",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "7.34",
      "y": "32.19",
      "width": "2.67",
      "height": "3.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "6.08",
      "y": "32.9",
      "width": "1.27",
      "height": "2.46",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "3.14",
      "y": "33.19",
      "width": "2.94",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.58",
      "y": "32.82",
      "width": "1.56",
      "height": "2.54",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.56",
      "y": "35.41",
      "width": "8.93",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "7.34",
      "y": "37.84",
      "width": "2.67",
      "height": "2.61",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "3.14",
      "y": "37.45",
      "width": "4.1",
      "height": "3",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.19"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.58",
      "y": "37.84",
      "width": "1.56",
      "height": "2.61",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.56",
      "y": "40.49",
      "width": "8.93",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "25.91",
      "y": "6.13",
      "width": "2.48",
      "height": "3.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24.73",
      "y": "6.84",
      "width": "1.18",
      "height": "2.46",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22",
      "y": "7.14",
      "width": "2.73",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.55",
      "y": "6.76",
      "width": "1.45",
      "height": "2.54",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.53",
      "y": "9.35",
      "width": "8.3",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "25.91",
      "y": "10.71",
      "width": "2.48",
      "height": "2.27",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22",
      "y": "10.81",
      "width": "3.81",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.15"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.55",
      "y": "11.44",
      "width": "1.45",
      "height": "1.53",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.53",
      "y": "13.02",
      "width": "8.3",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "20.77",
      "y": "14.1",
      "width": "2.42",
      "height": "3.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23.2",
      "y": "14.81",
      "width": "1.15",
      "height": "2.46",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24.34",
      "y": "15.11",
      "width": "2.66",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.01",
      "y": "14.73",
      "width": "1.41",
      "height": "2.54",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.34",
      "y": "17.32",
      "width": "8.1",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "20.77",
      "y": "18.68",
      "width": "2.42",
      "height": "2.27",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23.29",
      "y": "18.78",
      "width": "3.72",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.15"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.01",
      "y": "19.41",
      "width": "1.41",
      "height": "1.53",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.34",
      "y": "20.99",
      "width": "8.1",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "25.91",
      "y": "22.35",
      "width": "2.48",
      "height": "3.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24.73",
      "y": "23.06",
      "width": "1.18",
      "height": "2.46",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22",
      "y": "23.36",
      "width": "2.73",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.55",
      "y": "22.99",
      "width": "1.45",
      "height": "2.54",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.53",
      "y": "25.57",
      "width": "8.3",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "25.91",
      "y": "27.84",
      "width": "2.48",
      "height": "2.27",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23.97",
      "y": "27.94",
      "width": "1.85",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "22.02",
      "y": "27.22",
      "width": "1.95",
      "height": "2.89",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.55",
      "y": "28.57",
      "width": "1.45",
      "height": "1.53",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.53",
      "y": "30.15",
      "width": "8.3",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "20.77",
      "y": "32.19",
      "width": "2.42",
      "height": "3.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23.2",
      "y": "32.9",
      "width": "1.15",
      "height": "2.46",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "24.34",
      "y": "33.19",
      "width": "2.66",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.01",
      "y": "32.82",
      "width": "1.41",
      "height": "2.54",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.34",
      "y": "35.41",
      "width": "8.1",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "20.77",
      "y": "37.84",
      "width": "2.42",
      "height": "2.61",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23.29",
      "y": "37.45",
      "width": "3.72",
      "height": "3",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.18"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.01",
      "y": "37.84",
      "width": "1.41",
      "height": "2.61",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.34",
      "y": "40.49",
      "width": "8.1",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "10.51",
      "y1": "5.34",
      "x2": "10.51",
      "y2": "41.31",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.62"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20.17",
      "y1": "5.34",
      "x2": "20.17",
      "y2": "41.31",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.62"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "10.5",
      "y": "5.67",
      "width": "9.62",
      "height": "7.3",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.46"
    }
  }), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "11.11",
      "y": "14.94",
      "width": "2.74",
      "height": "2.27",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.12",
      "y": "15.04",
      "width": "4.2",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "18.33",
      "y": "15.68",
      "width": "1.6",
      "height": "1.53",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "10.79",
      "y": "17.25",
      "width": "9.16",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "16.81",
      "y": "19.13",
      "width": "2.84",
      "height": "3.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "15.47",
      "y": "19.84",
      "width": "1.34",
      "height": "2.46",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "12.35",
      "y": "20.13",
      "width": "3.12",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "10.69",
      "y": "19.76",
      "width": "1.66",
      "height": "2.54",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "10.67",
      "y": "22.35",
      "width": "9.48",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "11.17",
      "y": "24.22",
      "width": "2.75",
      "height": "2.27",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.03",
      "y": "24.32",
      "width": "4.23",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "18.25",
      "y": "24.96",
      "width": "1.61",
      "height": "1.53",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "10.67",
      "y": "26.54",
      "width": "9.2",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "16.81",
      "y": "33.06",
      "width": "2.84",
      "height": "3.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "15.47",
      "y": "33.76",
      "width": "1.34",
      "height": "2.46",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "12.35",
      "y": "34.06",
      "width": "3.12",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "10.69",
      "y": "33.69",
      "width": "1.66",
      "height": "2.54",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "10.67",
      "y": "36.27",
      "width": "9.48",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "11.17",
      "y": "38.15",
      "width": "2.75",
      "height": "2.27",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.03",
      "y": "38.25",
      "width": "4.23",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.16"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "18.25",
      "y": "38.89",
      "width": "1.61",
      "height": "1.53",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "10.67",
      "y": "40.47",
      "width": "9.2",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.14"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "11.28",
      "y": "28.41",
      "width": "2.74",
      "height": "3.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "14.02",
      "y": "29.12",
      "width": "1.3",
      "height": "2.46",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "15.32",
      "y": "29.42",
      "width": "3.01",
      "height": "2.17",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "18.33",
      "y": "29.05",
      "width": "1.6",
      "height": "2.54",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "10.79",
      "y": "31.63",
      "width": "9.16",
      "height": "0.67",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.13"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.type === 3) ? _c('svg', {
    attrs: {
      "id": "Layer_1",
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 30.19 50.14"
    }
  }, [_c('title', [_vm._v("icons")]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0.82",
      "y": "0.82",
      "width": "28.55",
      "height": "48.49",
      "fill": "none",
      "stroke": "#010101",
      "stroke-width": "1.64"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0.82",
      "y": "43.59",
      "width": "28.55",
      "height": "5.73",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.41"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0.82",
      "y": "0.82",
      "width": "28.55",
      "height": "4.52",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.36"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.62",
      "y": "5.46",
      "width": "18.26",
      "height": "7.51",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "2.16",
      "y": "6.08",
      "width": "17.17",
      "height": "6.26",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.09"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1.62",
      "y": "13.39",
      "width": "8.88",
      "height": "7.51",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "10.76",
      "y": "13.39",
      "width": "8.88",
      "height": "22.69",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "11.41",
      "y": "14",
      "width": "7.59",
      "height": "21.48",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.11"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "2.25",
      "y": "13.93",
      "width": "7.61",
      "height": "6.43",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.09"
    }
  }), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "19.99",
      "y": "5.46",
      "width": "8.88",
      "height": "7.51",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.63",
      "y": "6",
      "width": "7.61",
      "height": "6.43",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.09"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "19.99",
      "y": "13.14",
      "width": "8.88",
      "height": "7.51",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.63",
      "y": "13.68",
      "width": "7.61",
      "height": "6.43",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.09"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "19.99",
      "y": "20.81",
      "width": "8.88",
      "height": "7.51",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.63",
      "y": "21.35",
      "width": "7.61",
      "height": "6.43",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.09"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "19.99",
      "y": "28.49",
      "width": "8.88",
      "height": "15.03",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.71"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20.63",
      "y": "29.14",
      "width": "7.61",
      "height": "13.68",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.09"
    }
  }), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "1.7",
      "y": "20.81",
      "width": "8.88",
      "height": "7.51",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "2.34",
      "y": "21.35",
      "width": "7.61",
      "height": "6.43",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.09"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "1.7",
      "y": "28.49",
      "width": "8.88",
      "height": "7.51",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "2.34",
      "y": "29.03",
      "width": "7.61",
      "height": "6.43",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.09"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "1.7",
      "y": "36",
      "width": "8.88",
      "height": "7.51",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "2.34",
      "y": "36.54",
      "width": "7.61",
      "height": "6.43",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.09"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    attrs: {
      "x": "10.76",
      "y": "36",
      "width": "8.88",
      "height": "7.51",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "11.4",
      "y": "36.54",
      "width": "7.61",
      "height": "6.43",
      "rx": "1.13",
      "fill": "none",
      "stroke": "#010101",
      "stroke-miterlimit": "10",
      "stroke-width": "0.09"
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe558a92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planoList/SystemTypeIcon.vue
// module id = 3410
// module chunks = 0